'use client';

import { useGa4UserId } from '@hooks/analytics/useGa4UserId';

/**
 * @description Mounts a listener that keeps GA4 user_id in sync via GTM (through dataLayer auth_state events).
 */
export const Ga4UserLinker = () => {
  useGa4UserId();
  return null;
};
